const {
  Document, Paragraph, Packer, TableRow, TableCell, Table, WidthType, ImageRun, Header, TextRun, HeadingLevel,
  AlignmentType, Footer
} = require('docx')
const { saveAs } = require('file-saver')
const utils = require('../util/utils')
const { getUserPartner } = require('fleetmap-partners')
const colWidth = 2000

function formatCellValue (value) {
  return value.toLocaleDateString ? value.toLocaleDateString() : value + ''
}

exports.reportToWord = async (userData, dateRange, excel, title) => {
  console.log('excel', excel)
  const partnerData = getUserPartner(userData.user)

  if (!excel.data.length && utils.isClientSide()) {
    alert('Não há dados')
    return
  }
  const logo = await utils.getLogo(userData.user)
  console.log('logo', logo)
  const table = new Table({
    columnWidths: excel.headers.map(() => colWidth),
    rows: [
      new TableRow({
        children: excel.headers.map(r => new TableCell({
          children: [new Paragraph(r.label)],
          width: {
            size: colWidth,
            type: WidthType.DXA
          }
        }))
      }),
      ...excel.data.filter(r => Object.keys(r).length).map(r => new TableRow({
        children: Object.keys(r).map(k =>
          new TableCell({
            children: [new Paragraph(formatCellValue(r[k]))],
            width: {
              size: colWidth,
              type: WidthType.DXA
            }
          }))
      }))
    ]
  })
  const doc = new Document({
    sections: [{
      headers: {
        default: new Header({
          children: [
            new Paragraph({
              children: [
                new ImageRun({
                  data: logo,
                  transformation: {
                    width: (partnerData.reports && partnerData.reports.logoWidth * 2) || 200,
                    height: (partnerData.reports && partnerData.reports.logoHeight * 2) || 50
                  }
                })
              ]
            })
          ]
        })
      },
      footers: {
        default: new Footer({
          children: [
            new Paragraph({
              children: [
                new TextRun('Relatório gerado a ' + new Date().toLocaleString())
              ]
            })
          ]
        })
      },
      properties: {},
      children: [
        new Paragraph({
          children: [new TextRun(title)],
          heading: HeadingLevel.HEADING_1,
          alignment: AlignmentType.CENTER
        }),
        new Paragraph({}),
        new Paragraph(new Date(dateRange[0]).toLocaleString() + ' - ' + new Date(dateRange[1]).toLocaleString()),
        new Paragraph({}),
        table
      ]
    }]
  })
  Packer.toBlob(doc).then(blob => {
    saveAs(blob, 'report.docx')
  })
}
